import http from 'core/http';
import Popover from 'modules/components/Popover';

// お気に入り
export default class LikeUserButton {
  constructor(el) {
    this.el = el;
    this.initialize();
  }

  initialize() {
    new Vue({
      el: this.el,
      name: 'LikeUserButton',
      components: {
        Popover,
      },
      data() {
        return {
          API_URL: '/api/likes',
          LIKE_TEXT: 'お気に入りに追加',
          LIKED_TEXT: 'お気に入り済',
          LIKABLE_TYPE: 'User',
          isLiked: false,
          isLoading: false,
          isPopover: false,
        };
      },
      mounted() {
        this.isLiked = this.$el.hasAttribute('data-is-liked-default');
      },
      methods: {
        async handleClick(user) {
          if (this.isLoading) {
            return;
          }
          this.isLoading = true;
          if (this.isLiked) {
            await this.unlikeUser(user);
          } else {
            await this.likeUser(user);
            this.isPopover = true;
          }
          this.isLoading = false;
        },
        async unlikeUser(user) {
          await this.removeLike(user.id);
          this.isLiked = false;
        },
        async likeUser(user) {
          await this.postLike(user.id);
          this.isLiked = true;
        },
        async postLike(id) {
          await http.post(this.API_URL, {
            like: { likable_type: this.LIKABLE_TYPE, likable_id: id },
          });
        },
        async removeLike(id) {
          await http.post(this.API_URL, {
            like: { likable_type: this.LIKABLE_TYPE, likable_id: id },
            delete: 'true',
          });
        },
        closePopover() {
          this.isPopover = false;
        },
      },
    });
  }
}
